import React, { Component } from 'react';
import Notifications from 'modules/notifications';
import ErrorHandler from 'modules/error-handler';
import Header from 'modules/header';
import {AppRoutes} from 'modules/router';

import './Layout.css';


export default class Layout extends Component{

    render(){
        return(
            <div className="layout">
                <Notifications/>
                <ErrorHandler/>
                <Header appState = {this.props.appState} />
                <AppRoutes appState = {this.props.appState} />
                {/* <div>
                    {this.props.children}
                </div> */}
                

            </div>
        );
    }

}


// WEBPACK FOOTER //
// ./src/layout/Layout.jsx